import { Auth } from 'aws-amplify';
import { withHandlers, compose } from 'recompose';
import { withApollo } from 'react-apollo';

export type LogoutProps = {
  logout: (event: any) => Promise<void>;
};

export const withLogout = compose(
  withApollo,
  withHandlers({
    logout: ({ client }) => async (event: any) => {
      event.preventDefault();
      await Auth.signOut();
      console.log(client);
      client.resetStore();
    },
  }),
);



// WEBPACK FOOTER //
// ./src/helpers/withLogout.tsx